import { render } from "./PaymentInitSuccessComponent.vue?vue&type=template&id=70b82ae3"
import script from "./PaymentInitSuccessComponent.vue?vue&type=script&lang=js"
export * from "./PaymentInitSuccessComponent.vue?vue&type=script&lang=js"

import "./PaymentInitSuccessComponent.vue?vue&type=style&index=0&id=70b82ae3&lang=css"

import exportComponent from "/home/user/devops/sourcecode/Sopecam/sopecam-cameroontribune-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__